import type { SubmitEditorPluginOptions } from '@atlaskit/editor-plugin-submit-editor';

interface Props {
	options: never;
}

export function submitEditorPluginOptions({}: Props): SubmitEditorPluginOptions | undefined {
	return undefined;
}
